<template>
	<div>
		<el-upload class="upload-demo" ref="upload" action="" multiple :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="autoUpload" :before-upload="handleBeforeUpload" :http-request="handleUploadFile">
			<slot name="default" />
			<div class="el-upload__tip" slot="tip">
				<slot name="tip" />
			</div>
		</el-upload>
	</div>
</template>

<script>
import OSS from "ali-oss"
import { preUpload } from "@/api/pm/mfgApi"
function noop () { }
export default {
	props: {
		action: {
			type: String,
			default: ''
		},
		headers: {
			type: Object,
			default () {
				return {};
			}
		},
		data: Object,
		multiple: Boolean,
		name: {
			type: String,
			default: 'file'
		},
		drag: Boolean,
		dragger: Boolean,
		withCredentials: Boolean,
		showFileList: {
			type: Boolean,
			default: true
		},
		accept: String,
		type: {
			type: String,
			default: 'select'
		},
		fileList: {
			type: Array,
			default () {
				return [];
			}
		},
		autoUpload: {
			type: Boolean,
			default: true
		},
		listType: {
			type: String,
			default: 'text' // text,picture,picture-card
		},
		disabled: Boolean,
		limit: Number,
		uploadStyle: {
			type: Object,
			default: () => { return {} }
		}
	},
	data () {
		return {
			authData: {},
			ossClient: null,
			upload: {},
			checkpoints: {},
			multiPartConfig: {
				parallel: 1,
				partSize: 1024 * 1024,
				progress: this.handleUploadProgress
			},
		};
	},
	methods: {
		async submitUpload () {
			await this.initOssClient();
			this.$refs.upload.submit();
		},
		handleRemove (file, fileList) {
			// console.log("rm", file, fileList);
		},
		handlePreview (file) {
			// console.log("prev:", file);
		},
		async handleBeforeUpload (file) {
			// 数据库 标记开始上传
			// const upload = await this.$axios.post("/api/AliOSS/upload", {
			// 	filename: file.name,
			// 	uploadTime: new Date(),
			// 	status: "uploading"
			// });
			this.$set(this.upload, `${file.uid}`, {
				filename: file.name,
				uploadTime: new Date(),
				status: "uploading"
			});
		},
		async handleUploadFile (param) {
			// 单片上传
			this.singlePartUpload(param.file)
			// 分片上传
			// this.multiPartUpload(param.file);
			// this.$axios
			// 	.post(`${this.authData[`${param.file.uid}`].host}`, formData, config)
			// 	.then(res => {
			// 		this.$refs.upload.handleSuccess(res, param.file);
			// 		this.handleUploadSuccess(param.file);
			// 	})
			// .catch(error => {
			// 	this.$refs.upload.handleError(error, param.file);
			// 	this.handleUploadError(param.file);
			// });
		},
		handleUploadSuccess (file) {
			this.upload[`${file.uid}`].status = "upload finished";
			// this.$axios.put("/api/AliOSS/upload", this.upload[`${file.uid}`]);
		},
		handleUploadError (file, msg) {
			this.upload[`${file.uid}`].status = msg;
			// console.log(file, msg, 'eoorr');
			// this.$axios.put("/api/AliOSS/upload", this.upload[`${file.uid}`]);
		},
		handleUploadProgress (progress, checkpoint) {
			// this.$refs.uploadlog
			// console.log(progress, checkpoint);
			this.$set(this.checkpoints, `${checkpoint.uploadId}`, checkpoint);
			this.$refs.upload.handleProgress(
				{
					percent: progress * 100
				},
				checkpoint.file
			);
		},
		handleUploadStop () {
			if (this.ossClient) {
				this.ossClient.cancel();
			}
		},
		handleUploadResume () {
			this.resumeMultiPartUpload()
		},
		async initOssClient () {
			// 初始化 OSS客户端
			const auth = await preUpload();
			this.ossClient = new OSS({
				accessKeyId: auth.data.AccessKeyId,
				accessKeySecret: auth.data.AccessKeySecret,
				bucket: auth.data.Bucket,
				region: `oss-cn-shenzhen`,
				stsToken: auth.data.SecurityToken,
				cname: true,
				endpoint: process.env.VUE_APP_RES_URL,
			});
		},
		async multiPartUpload (file) {
			if (!this.ossClient) {
				await this.initOssClient();
			}
			this.ossClient
				.multipartUpload(file.name, file, {
					progress: this.multiPartConfig.progress
				})
				.then(res => {
					this.$refs.upload.handleSuccess(res, file)
					this.handleUploadSuccess(file, res.name);
				})
				.catch(res => {
					this.handleUploadError(file, res.name);
				});
		},


		async singlePartUpload (file) {
			if (!this.ossClient) {
				await this.initOssClient();
			}
			this.ossClient
				.put(new Date().valueOf() + file.name, file)
				.then(res => {
					this.$refs.upload.handleSuccess(res, file)
					this.handleUploadSuccess(file, res.name);
				})
				.catch(res => {
					this.handleUploadError(file, res.name);
				});
		},


		async resumeMultiPartUpload () {
			if (!this.ossClient) {
				await this.initOssClient();
			}
			Object.values(this.checkpoints).forEach(checkpoint => {
				const { uploadId, file } = checkpoint;
				this.ossClient.multipartUpload(uploadId, file, {
					parallel: this.multiPartConfig.parallel,
					partSize: this.multiPartConfig.partSize,
					progress: this.multiPartConfig.progress,
					checkpoint: checkpoint
				}).then(res => {
					// this.$delete(this.checkpoints, uploadId)
					this.handleUploadSuccess(file, res.name)
				}).catch(res => {
					this.handleUploadError(file, res.name)
				})
			});
		}
	}
};
</script>